import cn from 'classnames';
import { forwardRef, useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { IconButton } from '../icon-button/icon-button';
import { Input, InputProps } from './input';
import s from './input.module.css';

export const PasswordInput = forwardRef<HTMLInputElement, Omit<InputProps, 'type'>>(
  (props, ref) => {
    const { className, value = '', ...other } = props;

    const [inputType, setInputType] = useState('password');
    const handleChangeInputType = () =>
      setInputType(inputType === 'password' ? 'text' : 'password');

    return (
      <div className={cn(s.component, className)}>
        <Input ref={ref} type={inputType} value={value} {...other} />
        <IconButton
          variant="ghost"
          className={cn(s.eye, s[props.size || 'md'])}
          onClick={handleChangeInputType}
          disabled={props.disabled}
        >
          {inputType === 'password' ? <FiEyeOff /> : <FiEye />}
        </IconButton>
      </div>
    );
  },
);
